import {createStore} from 'redux';
import reducer from '../reducers';

const defaultState = {
    modalShow: false,
    teamBox: 0,
    contactContent: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        company: null,
        message: null,
        honeyPot: null
    }
}

const store = createStore(reducer);

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js